import setStatic from "./setStatic";
export var setDisplayName = function (name) { return setStatic("displayName", name); };
export default setDisplayName;

//# sourceMappingURL=setDisplayName.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/setDisplayName.js
// module id = 191
// module chunks = 0